import React from "react";
import { Spinner } from "react-bootstrap";
import { ReactComponent as SmilyFaceImg } from "assets/icons/empty.svg";
import { ResponseHandlerProps } from "./ResponseHandler.props";

const ResponseHandler = React.memo<ResponseHandlerProps>(
    ({
        isEmpty = false,
        errorMessage = undefined,
        loading,
        error,
        children,
        noDataText,
        isInput,
    }) => {
        if (!!loading) {
            return (
                <div className="w-100">
                    {isInput ? (
                        <Spinner
                            animation="grow"
                            role="status"
                            size="sm"
                            data-testid="spinner"
                            style={{
                                marginInline: "10px",
                                backgroundColor: "#5CBDA1",
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                height: "calc(100vh - 300px)",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Spinner
                                style={{ alignSelf: "center" }}
                                animation="border"
                                role="status"
                                data-testid="spinner"
                            />
                        </div>
                    )}
                </div>
            );
        }

        if (!!error) {
            return (
                <span className="text-danger w-100 text-center mt-5">
                    {errorMessage ? errorMessage : "خطایی رخ داده است."}
                </span>
            );
        }

        if (isEmpty) {
            return (
                <div className="empty-list">
                    <SmilyFaceImg />
                    <h6 className="mt-4">{noDataText ?? "آیتمی یافت نشد"}</h6>
                </div>
            );
        }

        return <>{children}</>;
    }
);

export default ResponseHandler;
